"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Parametro = void 0;
const typeorm_1 = require("typeorm");
const base_entity_1 = require("sol-orm-ts/dist/base-entity");
let Parametro = class Parametro extends base_entity_1.CustomBaseEntity {
    constructor() {
        super(...arguments);
        this.cdParametro = void (0);
        this.cdEmpresa = void (0);
        this.nmParametro = void (0);
        this.tpDado = void (0);
        this.tpApresentacao = void (0);
        this.nmRotulo = void (0);
        this.txtUrlFiltro = void (0);
        this.cdPessoa = void (0);
        this.tpParametro = void (0);
        this.cdModulo = void (0);
        this.cdSistema = void (0);
        this.tpNivelAcesso = void (0);
    }
};
__decorate([
    typeorm_1.Column("integer", { primary: true, name: "cd_parametro", nullable: true }),
    __metadata("design:type", Number)
], Parametro.prototype, "cdParametro", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "cd_empresa", nullable: true }),
    __metadata("design:type", Number)
], Parametro.prototype, "cdEmpresa", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nm_parametro", nullable: true }),
    __metadata("design:type", String)
], Parametro.prototype, "nmParametro", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "tp_dado", nullable: true }),
    __metadata("design:type", Number)
], Parametro.prototype, "tpDado", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "tp_apresentacao", nullable: true }),
    __metadata("design:type", Number)
], Parametro.prototype, "tpApresentacao", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nm_rotulo", nullable: true }),
    __metadata("design:type", String)
], Parametro.prototype, "nmRotulo", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "txt_url_filtro", nullable: true }),
    __metadata("design:type", String)
], Parametro.prototype, "txtUrlFiltro", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "cd_pessoa", nullable: true }),
    __metadata("design:type", Number)
], Parametro.prototype, "cdPessoa", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "tp_parametro", nullable: true }),
    __metadata("design:type", Number)
], Parametro.prototype, "tpParametro", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "cd_modulo", nullable: true }),
    __metadata("design:type", Number)
], Parametro.prototype, "cdModulo", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "cd_sistema", nullable: true }),
    __metadata("design:type", Number)
], Parametro.prototype, "cdSistema", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "tp_nivel_acesso", nullable: true }),
    __metadata("design:type", Number)
], Parametro.prototype, "tpNivelAcesso", void 0);
Parametro = __decorate([
    typeorm_1.Entity('grl_parametro')
], Parametro);
exports.Parametro = Parametro;
